<template>
  <div class="row" id="mainBody">
    <div class="col-lg-10 col-md-9 mainPanel">
      <div class="textEditor form-group">
        <label for="">Naam</label>
        <input
          autocomplete="false"
          v-model="templatefield.name"
          type="text"
          class="form-control"
        />
      </div>

      <div class="textEditor form-group">
        <label for="">Onderwerp</label>
        <input
          autocomplete="false"
          v-model="templatefield.subject"
          type="text"
          class="form-control"
        />
      </div>
      <div class="textEditor form-group">
        <label for="">Verstuur</label>
        <select
          v-model="templatefield.verstuur"
          class="w-100 form-control"
          style="height: 40px"
          @change="changeSettings($event)"
        >
          <option value="">-- Standaard Verstuur --</option>
          <option value="Nooit">Nooit </option>
          <option value="Direct">Direct </option>
          <option value="Dagelijks">Dagelijks</option>
        </select>
      </div>
      <div class="textEditor form-group">
        <label for="">BCC</label>
        <select2-multiple-control
          v-model="users"
          :options="format_user_arr"
          :settings="{ tags: true }"
          @select="mySelectEvent($event)"
          placeholder="Choose users or enter a valid emailaddresses"
        />
      </div>
      <div class="textEditor mb-3">
        <div class="d-flex justify-content-between mb-2">
          <label for="">Mailtemplate</label>
          <button
            v-if="has_models"
            data-toggle="modal"
            data-target="#modelsAttribute"
            class="btn btn-primary"
          >
            <i class="fas fa-info"></i>
          </button>
        </div>
        <editor
          v-model="templatefield.content"
          :init="{
            height: 400,
            menubar: false,
            language: 'nl',
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | link code | paste | fullscreen | removeformat | help',
          }"
        />
      </div>
      <div v-if="message.length > 0" class="alert alert-success">
        <p>
          {{ message }}
        </p>
      </div>
      <button @click="saveToServer()" class="btn btn-success">
        <i class="fa fa-save"></i> Opslaan
      </button>
    </div>
    <div class="col-lg-2 col-md-3">
      <button
        data-toggle="modal"
        data-target="#emailPreview"
        class="btn btn-dark text-white"
        @click="loadPreview()"
      >
        <i class="fa fa-eye"></i> Voorbeeld
      </button>
      <div
        class="modal fade"
        id="emailPreview"
        tabindex="-1"
        role="dialog"
        aria-labelledby="emailPreview"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header" style="border-bottom: unset">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="preview_loading">
              Aan het laden...
            </div>
            <div class="modal-body" v-else v-html="preview_content"></div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="has_models"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelattributes"
      aria-hidden="true"
      id="modelsAttribute"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <div class="accordion" id="accordionExample">
              <div
                v-for="(model, field) in models"
                :key="field"
                class="accordion-item"
              >
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    {{ field }}
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <table>
                      <thead>
                        <tr>
                          <th>Code</th>
                          <th>Voorbeeld</th>
                          <th>Veld</th>
                          <th>Beschrijving</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(attr, field) in model" :key="field">
                          <td>{{ field }}</td>
                          <td>{{ field.example }}</td>
                          <td>{{ field.title }}</td>
                          <td>{{ field.description }}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>
                            <a
                              @click="setModel(model)"
                              data-dismiss="modal"
                              data-toggle="modal"
                              href="#emailModal"
                              ><i class="fas fa-envelope"></i
                            ></a>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="emailModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="emailModal"
      aria-hidden="true"
    >
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <form @submit="sendMail($event)">
              <div class="form-group">
                <label for="">Verstuur emailvoorbeeld aan</label>
                <input
                  type="email"
                  v-model="model_email_field"
                  class="form-control"
                />
              </div>

              <div class="d-flex justify-content-between">
                <button class="btn btn-danger" data-dismiss="modal">
                  Annuleer
                </button>
                <button class="btn btn-success">Verstuur</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2MultipleControl from "v-select2-multiple-component";
import models from "../../../../mailtemplate_model_attributes.json";
export default {
  components: {
    Select2MultipleControl,
  },
  name: "index",
  data() {
    return {
      templatefield: {
        name: "",
        subject: "",
        verstuur: "",
        content: "",
        identifier: "",
        settings: {
          sent: {
            direct: false,
            daily: false,
          },
        },
      },
      models: models,
      model_email_field: "",
      active_model: null,
      preview: 0,
      preview_loading: true,
      preview_content: "",
      message: "",
      format_user_arr: [],
      users: [],
      has_models: false,
      reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  async created() {
    this.model_email_field = this.$store.state.auth.user.email;
    let id = this.$route.params.id;
    await this.$store
      .dispatch("get", "/api/v1/mailtemplates/" + id)
      .then((data) => {
        let template = data.data;
        console.log(template);

        this.users = template.data.bcc;
        this.templatefield.id = template.data.id;
        this.templatefield.name = template.data.name;
        this.templatefield.subject = template.data.subject;
        this.templatefield.content = template.data.content;
        this.templatefield.identifier = template.data.identifier;

        if (template.data.settings != null && template.data.settings.sent) {
          this.templatefield.settings = template.data.settings;

          if (
            !this.templatefield.settings.sent.direct &&
            !this.templatefield.settings.sent.daily
          ) {
            this.templatefield.verstuur = "Nooit";
          } else if (
            !this.templatefield.settings.sent.direct &&
            this.templatefield.settings.sent.daily
          ) {
            this.templatefield.verstuur = "Dagelijks";
          } else {
            this.templatefield.verstuur = "Direct";
          }
        }

        if (template.data.models != null) {
          try {
            var tmp = JSON.parse(template.data.models);
            if (tmp.length > 0) {
              this.has_models = true;
            }
          } catch (e) {
            //
          }
        }

        /* if(template.data.name != null && template.data.name != ''){
                this.templatefield=JSON.parse(template.content);
                template.content='';
                this.templatefield=template;
            } */
      })
      .catch((error) => {
        console.log(error.request);
      });

    this.$store.dispatch("get", "api/v1/users/all").then((data) => {
      this.users_arr = data.data.data;
      for (let i = 0; i <= this.users_arr.length; i++) {
        if (typeof this.users_arr[i] != "undefined") {
          this.format_user_arr.push({
            id: this.users_arr[i].email,
            text:
              this.users_arr[i].firstname + " " + this.users_arr[i].lastname,
          });
        }
      }
    });
  },
  methods: {
    setModel(data) {
      this.active_model = data;
    },
    async sendMail(e) {
      e.preventDefault();

      if (
        this.model_email_field.trim().length == 0 ||
        this.active_model == null
      ) {
        return;
      }

      var temp = {};
      for (var field in this.active_model) {
        temp[field] = this.active_model[field]["example"];
      }

      var response = await this.$store.dispatch("post", {
        endpoint: "api/v1/mailtemplates/" + this.templatefield.id + "/send",
        details: {
          address: this.model_email_field,
          model: temp,
        },
      });

      if (response.status == 200) {
        window.$("#emailModal").modal("hide");
        this.message = "Mail was sent successfully";
      }
    },
    changeSettings(event) {
      if (this.templatefield.settings == null) {
        this.templatefield.settings = {};
      }
      if (event.target.value == "Nooit") {
        this.templatefield.settings.sent.direct = false;
        this.templatefield.settings.sent.daily = false;
      } else if (event.target.value == "Dagelijks") {
        this.templatefield.settings.sent.direct = false;
        this.templatefield.settings.sent.daily = true;
      } else {
        this.templatefield.settings.sent.direct = true;
        this.templatefield.settings.sent.daily = false;
      }
    },
    saveToServer() {
      let template = this.templatefield;
      // let sections=JSON.stringify(this.templatefield);
      // template.content=sections;
      let id = this.$route.params.id;

      let content = template.content;
      this.$store
        .dispatch("put", {
          endpoint: "/api/v1/mailtemplates/" + id,
          details: {
            name: template.name,
            identifier: template.identifier,
            subject: template.subject,
            content: content,
            settings: JSON.stringify(template.settings),
            bcc: this.users,
          },
          notification: {
            title: "Mail Template",
            text: "Mail template Updated.",
            type: "success",
          },
        })
        .then((data) => {
          console.log(data);
          this.message = "Mailtemplates was updated successfully";
          window.location.href = "/settings/mailtemplates";
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    loadPreview() {
      this.preview_loading = true;
      let id = this.$route.params.id;
      this.$store
        .dispatch("get", "/api/v1/mailtemplates/" + id + "/preview")
        .then((data) => {
          this.preview_loading = false;
          this.preview_content = data.data.html;
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    mySelectEvent({ id }) {
      if (!this.reg.test(id)) {
        this.users.splice(this.users.indexOf(id), 1);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.accordion-item {
  border: 1px solid lightgrey;
  border-radius: 5px;
}
.accordion-item h2 {
  margin: 0px;
}
.accordion-item h2 button {
  border: none;
  width: 100%;
  text-align: left;
  font-size: 20px;
  height: 100%;
  display: block;
  padding: 15px;
  background: #d3d3d33b;
}
.accordion-item h2 button:focus {
  outline: none;
}
.accordion-collapse {
  padding: 15px;
}
.accordion-collapse table tbody tr {
  border-bottom: 1px solid lightgray;
  height: 40px;
}
.modal-body table {
  width: 100% !important;
}
</style>
